import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import * as zc from '@dvsl/zoomcharts';

@Component({
  selector: 'app-piechart',
  templateUrl: './piechart.component.html',
  styleUrls: ['./piechart.component.css']
})
export class PiechartComponent implements AfterViewInit {

  @Input() chartID: string;
  @Input() settings: string;
  zc: any = zc;
  chart: any;
  
  constructor() { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    const PieChart = this.zc.PieChart;
    this.chart = new PieChart(this.settings);
  }
  
}
